require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-raffaele-cavadini.json") })
        }
      }, "path---interviste-raffaele-cavadini");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-raffaele-cavadini!./.cache/json/interviste-raffaele-cavadini.json
// module id = 687
// module chunks = 231608221292675